import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "universal-cookie";
import GetProxy from "../GetProxy";
import { constants } from "../utilities/constants";
import { logOut } from "../utilities/helpers";

const cookies = new Cookies();
const proxy = GetProxy();

const baseQuery = fetchBaseQuery({
  baseUrl: constants.BASE_URL,
  prepareHeaders: (headers) => {
    const apiToken = cookies.get("apitoken");
    const username = cookies.get("username");
    headers.set("DTOP-API-TOKEN", apiToken);
    headers.set("USERNAME", username);
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result?.meta?.response?.status === 403) {
    logOut();
  } else if (result?.meta?.response?.redirected === true) {
    logOut();
  } else if (result?.meta?.response?.status === 401) {
    logOut();
  }
  return result;
};

export const apiLocal = createApi({
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Task"],
  reducerPath: "localApi",
  endpoints: (build) => ({
    login: build.mutation({
      query: (credentials) => ({
        url: `${proxy}/jwt/SignIn`,
        method: "POST",
        body: credentials,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }),
    }),
    getTopHeader: build.query({
      query: () => `${proxy}/jwt/getTopHeader`,
    }),
  }),
});
